import { Pipe, PipeTransform } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { IntlService } from '@frontend/vanilla/core';

@Pipe({ name: 'msMyBetsDateFormatter' })
export class MyBetsDateFormatterPipe implements PipeTransform {
    constructor(
        private sitecore: Sitecore,
        private intlService: IntlService,
    ) {}

    transform(value: Date, showTodayDate: boolean = true): any {
        const betDate = this.intlService.formatDate(value, 'shortDate');

        if (!showTodayDate) {
            return betDate;
        }

        const today = this.intlService.formatDate(new Date(), 'shortDate');

        return betDate === today ? this.sitecore.globalMessages.Today : betDate;
    }
}
